import { render, staticRenderFns } from "./Domestic.vue?vue&type=template&id=d1532100"
import script from "./Domestic.vue?vue&type=script&lang=js"
export * from "./Domestic.vue?vue&type=script&lang=js"
import style0 from "./Domestic.vue?vue&type=style&index=0&id=d1532100&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports